// This file allows you to configure ESLint according to your project's needs, so that you
// can control the strictness of the linter, the plugins to use, and more.

// For more information about configuring ESLint, visit https://eslint.org/docs/user-guide/configuring/
import RequestManager from "@/script/request"
import config from "@/config";
export default class GestionnaireDeCarte{
    static async setCarteCPS(obj, situation = 1) {
        try {
            const suffixe = situation ? ('?situation=' + situation) : '';
            const response = await RequestManager.post(config.urlBackEnd + 'SetCPS' + suffixe, obj);
            return response;
        } catch (error) {
            console.error('Erreur lors de l envoi des donnees CPS :', error);
            throw error;
        }
    }

    static getCarteCPS() {
        return RequestManager.get(config.urlBackEnd + "GetCPS")
            .then(response => {
                return response
            })
            .catch(error => console.log("error in FSEWithInfo.getCarteCPS : ", error));
    }

    static setCarteVitale(obj) {
        return RequestManager.post(config.urlBackEnd + 'SetVitale', obj).then(response => { return response; });
    }

    static getCarteVitale(obj) {
        return RequestManager.post(config.urlBackEnd + 'GetVitale', obj).then(response => { return response; });
    }
}
